import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'
import { ProjectDataType, ScenarioDataType } from './CreateScenarioPlan.types'

const fetchProjects = async () => {
  const data = await request({
    url: '/projects',
    baseURL: process.env.MODELLING_BASE_URL,
    method: 'get',
  })
  return data
}

export const useProjects = () => {
  return useQuery(['projects'], fetchProjects, {
    select: ({ data }) => {
      return data?.data.map((project: ProjectDataType) => {
        return {
          label: project.projectName,
          value: project.projectId,
        }
      })
    },
    refetchOnWindowFocus: false,
  })
}

const fetchScenarios = async (projectId: string) => {
  const data = await request({
    url: `/projects/${projectId}/details`,
    baseURL: process.env.MODELLING_BASE_URL,
    method: 'get',
  })
  return data
}

export const useScenarios = (projectId: string) => {
  return useQuery(['scenarios', projectId], () => fetchScenarios(projectId), {
    select: ({ data }) => {
      return data?.data?.scenariosList
        .filter((scenario: ScenarioDataType) => scenario.scenarioId !== null)
        .map((scenario: ScenarioDataType) => {
          return {
            label: scenario.scenarioName,
            value: scenario.scenarioId,
          }
        })
    },
    enabled: !!projectId,
    refetchOnWindowFocus: false,
  })
}
